"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleSpecs = void 0;
/**
 * Defines the ArticleSpecs (multi-selection possible)
 */
var ArticleSpecs;
(function (ArticleSpecs) {
    // espool-related
    ArticleSpecs["espoolOnly"] = "espoolOnly";
    ArticleSpecs["espoolReady"] = "espoolReady";
    // leitung-related
    ArticleSpecs["Chainflex"] = "Chainflex";
    ArticleSpecs["Readycable"] = "Readycable";
    ArticleSpecs["PullWire"] = "PullWire";
    ArticleSpecs["erkReady"] = "erkReady";
    // rolEchain-related
    ArticleSpecs["rolEchain"] = "rolEchain";
    ArticleSpecs["rolEchainOnly"] = "rolEchainOnly";
    ArticleSpecs["rolEchainRolLink"] = "rolEchainRolLink";
    ArticleSpecs["rolEchainAdapterLink"] = "rolEchainAdapterLink";
    ArticleSpecs["rolEchainModifiedLink"] = "rolEchainModifiedLink";
    ArticleSpecs["rolEchainAutoglideLink"] = "rolEchainAutoglideLink";
    ArticleSpecs["rolEchainGrease"] = "rolEchainGrease";
    // smartPlastics-related
    ArticleSpecs["ECPDummy"] = "ECPDummy";
    ArticleSpecs["ECPSensor"] = "ECPSensor";
    ArticleSpecs["ECPSensorCable"] = "ECPSensorCable";
    ArticleSpecs["ECW"] = "ECW";
    ArticleSpecs["ECWBlackbox"] = "ECWBlackbox";
    ArticleSpecs["ECWSensor"] = "ECWSensor";
    ArticleSpecs["ECWSensorCable"] = "ECWSensorCable";
    ArticleSpecs["ICeeModule"] = "ICeeModule";
    ArticleSpecs["IsenseModule"] = "IsenseModule";
    ArticleSpecs["SMSModule"] = "SMSModule";
    ArticleSpecs["SMSModuleCable"] = "SMSModuleCable";
    ArticleSpecs["SimCard"] = "SimCard";
    ArticleSpecs["SmartPlasticsOnly"] = "SmartPlasticsOnly";
})(ArticleSpecs = exports.ArticleSpecs || (exports.ArticleSpecs = {}));
//# sourceMappingURL=ArticleSpecs.js.map